import { Card } from '@design-system';
import {
  QuickPlanForm,
  useShortFormIntake,
  type QuickPlanFormValues,
} from '@/features/client-quick-plan';

interface QuickPlanCardProps {
  advisorId: string;
  title?: string;
  description?: string;
  onSubmitSuccess?: (data: ShortFormIntakeResponse) => void;
}

export function QuickPlanCard({
  advisorId,
  title = 'Quick Client Plan',
  description = 'Enter basic client info to create an abbreviated plan. No email invite needed.',
  onSubmitSuccess,
}: QuickPlanCardProps) {
  const { submitQuickPlan, isPending } = useShortFormIntake({
    advisorId,
    onSuccess: onSubmitSuccess,
  });

  function handleSubmit(data: QuickPlanFormValues) {
    submitQuickPlan(data);
  }

  return (
    <Card className="gap-6 p-6">
      <div className="space-y-1">
        <h3 className="text-xl font-semibold text-gray-950">{title}</h3>
        <p className="text-foreground text-base">{description}</p>
      </div>
      <QuickPlanForm
        onSubmit={handleSubmit}
        isSubmitting={isPending}
      />
    </Card>
  );
}
